import React, { useState, useEffect } from "react";
import api from "../../setupMiddleware";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import {
  getUser,
  hasPermission,
  isAdmin,
  isHR,
  isManager,
  isTL,
} from "../../Utils/auth";
import Popup from "../Common/Popup";
import FileUpload from "../Common/FileUpload";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { getFileType } from "../../Utils/getUserUtitls";
import { FaFilePdf } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import CustomSelect from "../Common/CustomSelect";
import Textarea from "../Common/Textarea";
import LeaveHistoryTable from "../Common/LeaveHistoryTable";
import moment from "moment/moment";
import { createLeaveFormData } from "../../Utils/getUserUtitls";
import DateRange from "../Common/DateRange";
import ChipInput from "../Common/ChipInput";
import PlaceholderImg from "../../assets/images/placeholder.jpg";
import StatCard from "../Common/StatCard";
import LogIcon from "../../assets/icons/log";
import AttendanceTable from "../Common/AttendanceTable";
import PlaceholderImage from "../../assets/images/placeholder.jpg";

const ViewEmployee = () => {
  const loading = useApiLoader();
  const { id } = useParams();
  // const [roleData, setRoleData] = useState([]);
  const [documentData, setDocumentData] = useState([]);
  const [generatedDocumentData, setGeneratedDocumentData] = useState([]);
  const [leaveHistory, setLeaveHistory] = useState([]);
  // const [departmentData, setDepartmentData] = useState([]);
  // const [locationData, setLocationData] = useState([]);
  // const [edit, setEdit] = useState(false);
  const [leaveSummary, setLeaveSummary] = useState({});
  // const [document, setDocument] = useState({
  //   document_type: "",
  //   file_path: [],
  // });

  // const [uploadOpen, setUploadOpen] = useState(false);
  const [noUserOpen, setNoUserOpen] = useState(false);
  const [apiErrorOpen, setApiErrorOpen] = useState(false);
  const [employee, setEmployee] = useState();
  const [hrData, setHrData] = useState([]);
  const [managerData, setManagerData] = useState([]);
  const [attendanceLog, setAttendanceLog] = useState([]);
  const [openImage, setOpenImage] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState({});

  const userData = getUser();

  const [activeTab, setActiveTab] = useState("about");

  const [applyLeaveOpen, setApplyLeaveOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const [leaveTypes, setLeaveTypes] = useState([]);
  console.log(employee);
  const [leave, setLeave] = useState({
    user_id: 0,
    hr_id: 0,
    tl_id: 0,
    leave_type: "",
    start_date: "",
    sub_type: "",
    end_date: "",
    medical_certificate: null,
    reason: "",
    applied_by: userData?.id,
    is_mannual: 1,
  });

  const {
    leave_type,
    sub_type,
    start_date,
    end_date,
    reason,
    medical_certificate,
    user_id,
    hr_id,
    tl_id,
    applied_by,
    is_mannual,
  } = leave;

  console.log(leave);

  const leaveTypeOptions = leaveTypes?.map((dep) => ({
    label: dep.name,
    value: dep.id,
  }));

  const leaveSubTypeOptions = [
    {
      label: "Full Day",
      value: "full_day",
    },
    {
      label: "First Half",
      value: "first_half",
    },
    {
      label: "Second Half",
      value: "second_half",
    },
    {
      label: "Short Leave",
      value: "short_leave",
    },
  ];

  const getLeaveType = async () => {
    try {
      await api.get("/api/leaves/types").then((res) => {
        if (res && res.status === 200) {
          const filteredData = res.data?.data
            ?.filter((item) => item.code !== "SL") // remove sick leave
            ?.map((item) => {
              if (item.code === "CL") {
                return {
                  ...item,
                  name: "Paid Leave",
                };
              }
              if (item.code === "LWP") {
                return {
                  ...item,
                  name: "Unpaid Leave",
                };
              }
              return item;
            })
            ?.sort((a, b) => {
              const aIsPaid = a.code === "PL" || a.name?.toLowerCase().includes("paid leave");
              const bIsPaid = b.code === "PL" || b.name?.toLowerCase().includes("paid leave");
              const aIsCasual = a.code === "CL" || a.name?.toLowerCase().includes("casual leave");
              const bIsCasual = b.code === "CL" || b.name?.toLowerCase().includes("casual leave");

              if (aIsPaid) return -1;
              if (bIsPaid) return 1;
              if (aIsCasual) return -1;
              if (bIsCasual) return 1;
              return 0;
            });

          setLeaveTypes(filteredData);
        }
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const getLeaveHistory = async () => {
    try {
      await api.get(`/api/leaves/history/${id}`).then((res) => {
        if (res && res.status === 200) {
          setLeaveHistory(res.data?.data);
        }
      });
    } catch (error) {
      alert("Something went wrong!");
    }
  };

  const getAttendanceLog = async (locId) => {
    await api
      .get(`/api/attendance/${id}`)
      .then((res) => {
        if (res && res.status === 200) {
          let newAttendanceData = [];
          // res.data?.data.lengh > 0 &&
          res.data?.data.map((a) => {
            newAttendanceData.push({
              ...a,
              location_id: locId,
            });
          });
          setAttendanceLog(newAttendanceData);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  console.log("attendanceLog", attendanceLog);

  const getProfileInfo = async () => {
    try {
      await api.get(`/api/user/${id}`).then((res) => {
        if (res && res.status === 200) {
          const resData = res.data?.data;
          setEmployee(res.data?.data);
          setLeave((prev) => ({
            ...prev,
            user_id: resData.id,
            hr_id: resData.hr_id,
            tl_id: resData.tl_id,
          }));
          getAllDocuments();
          getAttendanceLog(resData?.location_id);
        }
      });
    } catch (error) {
      if (error?.response?.data?.message === "User not found.") {
        setNoUserOpen(true);
      } else {
        setApiErrorOpen(true);
      }
    }
  };

  const getAllDocuments = async () => {
    api
      .get(`/api/employee-documents/${id}`)
      .then((res) => {
        if (res && res.status === 200) {
          setDocumentData(res.data?.data);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  };

  const applyLeave = async () => {
    setSubmitted(true);

    if (!leave_type || !start_date || !end_date || !reason) {
      setErrorMessage("Please fill all fields to apply for leave");
      return;
    }

    if (leave_type === 3 && !medical_certificate) {
      setErrorMessage("Please upload Medical Certificate");
      return;
    }
    try {
      const leaveData = {
        medical_certificate: medical_certificate,
        leave_type: leave_type,
        start_date: moment(new Date(start_date)).format("YYYY-MM-DD"),
        end_date: moment(new Date(end_date)).format("YYYY-MM-DD"),
        reason: reason,
        user_id: user_id,
        hr_id: hr_id,
        tl_id: tl_id,
        applied_by: applied_by,
        is_mannual: is_mannual,
      };
      const formData = createLeaveFormData(leaveData);
      await api.post("/api/leaves/apply", formData).then((res) => {
        if (res && res.status === 200) {
          setErrorMessage("");
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          setLeave({
            leave_type: "",
            start_date: "",
            end_date: "",
            medical_certificate: null,
            reason: "",
          });
          setApplyLeaveOpen(false);
          setSubmitted(false);
        }
      });
    } catch (error) {
      toast.error(error.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const handleApplyClose = () => {
    setLeave({
      leave_type: "",
      start_date: "",
      sub_type: "",
      end_date: "",
      medical_certificate: null,
      reason: "",
    });
    setApplyLeaveOpen(false);
    setSubmitted(false);
    setErrorMessage("");
  };

  const getLeaveSummary = async () => {
    await api
      .post(`/api/leaves/summary`, { user_id: id })
      .then((res) => {
        if (res && res.status === 200) {
          setLeaveSummary(res.data?.data);
        }
      })
      .catch((error) => {
        toast.error(error.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });
      });
  };

  const generateExperienceLetter = async () => {
    api
      .post(`/api/experience-letter`, { user_id: id })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          setTimeout(() => {
            window.open(res.data?.file_url, "_blank");
          }, 1500);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  };

  const getAllData = async () => {
    api.get("/api/master-data").then((res) => {
      if (res && res.status === 200) {
        const resData = res.data?.data;
        setHrData(resData?.hrs);
        setManagerData(resData?.managers);
      }
    });
  };

  const getAllGeneratedDocuments = async () => {
    api
      .post(`/api/request-documents/approved_by_id`, { user_id: id })
      .then((res) => {
        if (res && res.status === 200) {
          setGeneratedDocumentData(res.data?.data);
        }
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  };

  const handleTimeSelect = (pic) => {
    setSelectedPhoto(pic);
    setOpenImage(true);
  };

  const handleClosePhoto = () => {
    setSelectedPhoto("");
    setOpenImage(false);
  };

  const stats = [
    {
      title: "Leave Entitlement",
      value: leaveSummary?.total_leaves ? leaveSummary?.total_leaves : "0",
      Icon: LogIcon,
    },
    {
      title: "Leave Balance",
      value: leaveSummary?.leave_balance ? leaveSummary?.leave_balance : "0",
      Icon: LogIcon,
    },
    {
      title: "Approved Leaves",
      value: leaveSummary?.approved_leaves
        ? leaveSummary?.approved_leaves
        : "0",
      Icon: LogIcon,
    },
    {
      title: "Rejected Leaves",
      value: leaveSummary?.rejected_leaves
        ? leaveSummary?.rejected_leaves
        : "0",
      Icon: LogIcon,
    },
  ];

  useEffect(() => {
    if (id === 1) {
      window.location = "/employees";
    }
    getProfileInfo();
    getLeaveHistory();
    getLeaveType();
    getLeaveSummary();
    getAllData();
    getAllGeneratedDocuments();
    // getAllLocation();
  }, []);

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 5000); // 5s

      // cleanup if message changes before 5s
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const getManagerById = (id) => {
    const person = managerData.find((emp) => emp.id === id);
    return person ? `${person.first_name} ${person.last_name}` : "";
  };

  const getHrById = (id) => {
    const person = hrData.find((emp) => emp.id === id);
    return person ? `${person.first_name} ${person.last_name}` : "";
  };

  return (
    <>
      {loading && <Loader opacity={90} fullscreen />}
      {/* Top profile card */}
      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="bg-white border border-[#a48572]/20 rounded-3xl p-6 flex flex-col sm:flex-row gap-6 shadow-sm">
          {/* Avatar */}
          <div className="flex-shrink-0">
            <img
              src={employee?.employee_image || PlaceholderImg}
              alt={employee?.first_name + " " + employee?.last_name}
              className="w-48 h-48 rounded-2xl object-cover bg-[#de2b26]/20"
            />
          </div>

          {/* Info */}
          <div className="flex flex-col justify-between flex-1">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto gap-4">
              <div>
                <h1 className="text-2xl font-semibold text-[#de2b26]">
                  {employee?.first_name} {employee?.last_name}
                </h1>
                <p className="text-sm text-[#142b70]/70">
                  {employee?.role?.name}
                </p>
              </div>
              <div className="flex gap-2">
                {(isAdmin() || isHR()) && (
                  <button
                    onClick={() => generateExperienceLetter()}
                    className="px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] text-white text-sm"
                  >
                    Generate Experience Letter
                  </button>
                )}
                {(isAdmin() || isHR() || isTL() || isManager()) && (
                  <button
                    onClick={() => setApplyLeaveOpen(true)}
                    className="px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] text-white text-sm"
                  >
                    Request Leave
                  </button>
                )}
                {(isAdmin() || hasPermission("edit_employees")) && (
                  <Link
                    to={`/employee/${id}`}
                    className="px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] text-white text-sm"
                  >
                    Edit details
                  </Link>
                )}
                <Popup
                  isOpen={applyLeaveOpen}
                  onClose={() => handleApplyClose()}
                  title={`<div>${employee?.first_name + " " + employee?.last_name
                    }<br/><span style="font-size: 13px;margin-top: -10px;display: block;font-weight: 400;">Request Leave</span></div>`}
                  isHtml={true}
                >
                  <div className="flex flex-col gap-6 mt-[30px]">
                    {errorMessage && (
                      <div className="mb-4 w-full rounded-lg bg-red-50 border border-red-400 text-red-700 px-4 py-2">
                        {errorMessage}
                      </div>
                    )}
                    <div className="flex flex-col gap-2 w-full">
                      <p className="text-sm text-[#142b70]/80">Leave Type</p>
                      <CustomSelect
                        options={leaveTypeOptions}
                        value={leave_type}
                        placeholder="Leave Type"
                        width="w-full"
                        height="h-[46px]"
                        fontSize="14px"
                        onChange={(op) =>
                          setLeave({
                            ...leave,
                            leave_type: op.value,
                            sub_type: "",
                          })
                        }
                        error={!leave_type && submitted}
                      />
                    </div>
                    {leave_type === 3 && (
                      <div className="flex flex-col gap-2">
                        <div className="relative">
                          <FileUpload
                            label="Upload Medical Certificate"
                            accept=".jpg,.pdf,.doc"
                            multiple={false}
                            onChange={(file) =>
                              setLeave({ ...leave, medical_certificate: file })
                            }
                            required={true}
                            submitted={submitted}
                          />
                        </div>
                      </div>
                    )}
                    {(leave_type === 1 || leave_type === 4) && (
                      <div
                        className={`flex flex-col justify-center gap-2 w-full border border-gray-200 rounded-lg shadow-sm p-4 bg-white ${!sub_type && submitted ? "border-red-500" : ""
                          }`}
                      >
                        <p className="text-sm text-[#142b70]/80">
                          Leave Sub Type
                        </p>
                        <ChipInput
                          options={leaveSubTypeOptions}
                          onChange={(op) =>
                            setLeave({ ...leave, sub_type: op })
                          }
                          selected={sub_type}
                        />
                      </div>
                    )}
                    <div className="flex justify-center gap-5 w-full">
                      <DateRange
                        startDate={start_date}
                        endDate={end_date}
                        setStartDate={(date) =>
                          setLeave({ ...leave, start_date: date })
                        }
                        setEndDate={(date) =>
                          setLeave({ ...leave, end_date: date })
                        }
                        submitted={submitted}
                      />
                    </div>
                    <div className="flex flex-col gap-2 mb-4">
                      <p className="text-sm text-[#142b70]/80">Reason</p>
                      <div className="relative">
                        <Textarea
                          value={reason}
                          placeholder="Write a reason"
                          onChange={(e) =>
                            setLeave({
                              ...leave,
                              reason: e.target.value,
                            })
                          }
                          error={!reason && submitted}
                          rows={4}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Footer */}
                  <div className="flex justify-end gap-4">
                    <button
                      onClick={() => handleApplyClose()}
                      className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={applyLeave}
                      className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
                    >
                      Apply
                    </button>
                  </div>
                </Popup>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-4 gap-x-6 mt-4 text-sm text-[#142b70]/80">
              {[
                { label: "Office Email", value: employee?.office_email, isEmail: true },
                { label: "Phone", value: employee?.phone },
                { label: "Location", value: employee?.location?.name },
                { label: "Department", value: employee?.department?.name },
                { label: "Designation", value: employee?.designation?.title },
                { label: "Grade", value: employee?.grade?.title },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-start gap-2 rounded-lg p-1 pl-0 min-w-0"
                >
                  <div className="flex flex-col leading-tight min-w-0 w-full">
                    <span className="text-[11px] uppercase tracking-wide text-[#142b70]/60 font-medium">
                      {item.label}
                    </span>
                    <span
                      className={`text-sm text-[#142b70] font-semibold ${item.isEmail ? "break-all" : "truncate"
                        }`}
                      title={item.value || ""}
                    >
                      {item.value || "—"}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-6 border-b border-[#a48572]/20">
          <nav className="flex gap-6 text-sm">
            {[
              { id: "about", label: "About" },
              { id: "documents", label: "Documents" },
              { id: "leave", label: "Leave History" },
              { id: "attendance", label: "Attendance History" },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`pb-3 ${activeTab === tab.id
                    ? "border-b-2 border-[#de2b26] text-[#142b70] font-medium"
                    : "text-[#142b70]/70 hover:text-[#142b70]"
                  }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>
      <div className="mt-6">
        {activeTab === "about" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="bg-white border border-[#a48572]/10 rounded-2xl p-6">
              <p>
                <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                  About
                </span>
              </p>
              <hr />

              {/* Other info mapped automatically */}
              <div className="space-y-8 mt-8">
                {[
                  {
                    title: "Office Info",
                    items: [
                      { label: "Role", value: employee?.role?.name },
                      {
                        label: "Designation",
                        value: employee?.designation?.title,
                      },
                      { label: "Grade", value: employee?.grade?.title },
                      {
                        label: "Department",
                        value: employee?.department?.name,
                      },
                      ...(employee?.role_id === 3
                        ? [
                          {
                            label: "HR Head",
                            value: getHrById(employee?.hr_head),
                          },
                        ]
                        : employee?.role_id === 4
                          ? [
                            {
                              label: "Manager",
                              value: getManagerById(employee?.manager),
                            },
                          ]
                          : employee?.role_id === 8
                            ? [
                              {
                                label: "Team Leader",
                                value: employee?.team_leader,
                              },
                            ]
                            : []),
                      ...(employee?.role_id !== 3 ||
                        employee?.role_id !== 2 ||
                        employee?.role_id !== 1
                        ? [
                          {
                            label: "Hr",
                            value: getHrById(employee?.hr_id),
                          },
                        ]
                        : []),
                      {
                        label: "Job Location",
                        value: employee?.location?.name,
                      },
                    ],
                  },
                  {
                    title: "Personal Info",
                    items: [
                      { label: "Father Name", value: employee?.father_name },
                      { label: "Mother Name", value: employee?.mother_name },
                      { label: "Personal Email", value: employee?.email },
                      {
                        label: "Joining Date",
                        value: moment(employee?.joining_date).format(
                          "DD MMM, YYYY"
                        ),
                      },
                      {
                        label: "Emergency Contact",
                        value: employee?.emergency_contact,
                      },
                      {
                        label: "Date of Birth",
                        value: moment(employee?.dob).format("DD MMM, YYYY"),
                      },
                      { label: "Gender", value: employee?.gender },
                      {
                        label: "Marital Status",
                        value: employee?.marital_status,
                      },
                      {
                        label: "Place of Birth",
                        value: employee?.place_of_birth,
                      },
                      {
                        label: "Nationality",
                        value: employee?.nationality,
                      },
                      {
                        label: "Employee Personal Number",
                        value: employee?.employee_personal_number,
                      },
                      {
                        label: "Bank Account Number",
                        value: employee?.bank_account_number,
                      },
                      {
                        label: "Bank Routing Code",
                        value: employee?.bank_routing_code,
                      },
                      ...(employee?.location_id === 1
                        ? [
                          {
                            label: "Emirates Id",
                            value: employee?.emirate_id,
                          },
                        ]
                        : []),
                      {
                        label: "Passport Number",
                        value: employee?.passport_no,
                      },
                      {
                        label: "Permanent Address",
                        value: employee?.permanent_address,
                      },
                      {
                        label: "Current Address",
                        value: employee?.current_address,
                      },
                    ],
                  },
                ].map((group, gIdx) => (
                  <div key={gIdx}>
                    {/* Section title */}
                    <h3 className="text-lg font-bold text-[#142b70] mb-4 pb-1">
                      {group.title}
                    </h3>

                    {/* Cards grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {group.items.map((item, idx) => (
                        <div
                          key={idx}
                          className="flex items-start gap-2 bg-[#de2b26]/5 border-l-2 border-[#de2b26] rounded-lg p-3"
                        >
                          <div className="flex flex-col leading-tight">
                            <span className="text-[11px] uppercase tracking-wide text-[#142b70]/60 font-medium">
                              {item.label}
                            </span>
                            <span className="text-sm text-[#142b70] font-semibold">
                              {item.value || "—"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {activeTab === "documents" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="bg-white border border-[#a48572]/10 rounded-2xl p-6">
              <p>
                <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                  Documents
                </span>
              </p>
              <hr />
              <div className="flex my-10 gap-6">
                <div className="border-2 border-[#a48572]/10 rounded-2xl p-4 w-full max-w-96">
                  <p>
                    <span className="block text-xl sm:text-sm font-medium text-[#142b70]">
                      Uploaded Documents
                    </span>
                  </p>
                  <div className="flex items-center flex-col gap-2 mt-4 w-full">
                    {documentData.length > 0 ? (
                      documentData.map((doc) => (
                        <Link
                          to={doc.file_path}
                          target="_blank"
                          className="flex justify-start items-center gap-2 border-2 border-[#a48572]/10 rounded-2xl p-4 w-full"
                        >
                          <div>
                            {(getFileType(doc.file_path) === "jpeg" ||
                              getFileType(doc.file_path) === "jpg" ||
                              getFileType(doc.file_path) === "png") && (
                                <img
                                  src={doc.file_path}
                                  alt={doc.document_type}
                                  className="w-10 h-10 rounded-xl object-cover"
                                />
                              )}
                            {getFileType(doc.file_path) === "pdf" && (
                              <FaFilePdf className="text-[#c30f0a] text-2xl w-10" />
                            )}
                          </div>
                          <div>{doc.document_type}</div>
                        </Link>
                      ))
                    ) : (
                      <div className="text-[12px] text-[#c30f0a] text-left w-full">
                        No Document found.
                      </div>
                    )}
                  </div>
                </div>
                <div className="border-2 border-[#a48572]/10 rounded-2xl p-4 w-full max-w-96">
                  <p>
                    <span className="block text-xl sm:text-sm font-medium text-[#142b70]">
                      Generated Documents
                    </span>
                  </p>
                  <div className="flex items-center flex-col gap-2 mt-4 w-full">
                    {generatedDocumentData.length > 0 ? (
                      generatedDocumentData.map((doc) => (
                        <Link
                          to={doc.file_path}
                          target="_blank"
                          className="flex justify-start items-center gap-2 border-2 border-[#a48572]/10 rounded-2xl p-4 w-full"
                        >
                          <div>
                            {(getFileType(doc.file_path) === "jpeg" ||
                              getFileType(doc.file_path) === "jpg" ||
                              getFileType(doc.file_path) === "png") && (
                                <img
                                  src={doc.file_path}
                                  alt={doc.document_type}
                                  className="w-10 h-10 rounded-xl object-cover"
                                />
                              )}
                            {getFileType(doc.file_path) === "pdf" && (
                              <FaFilePdf className="text-[#c30f0a] text-2xl w-10" />
                            )}
                          </div>
                          <div>
                            {doc.document_type === "salary_transfer"
                              ? "Salary Transfer"
                              : doc.document_type === "noc"
                                ? "NOC"
                                : "N/A"}
                          </div>
                        </Link>
                      ))
                    ) : (
                      <div className="text-[12px] text-[#c30f0a] text-left w-full">
                        No Document found.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === "leave" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="w-full mx-auto p-8 relative rounded-xl bg-white border border-[#a48572]/10">
              <div className="flex flex-col justify-start items-start gap-[20px]">
                <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
                  <p>
                    <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                      Leave History
                    </span>
                  </p>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full mx-auto py-3">
                  {stats.map((stat, index) => (
                    <StatCard key={index} {...stat} />
                  ))}
                </div>
                <LeaveHistoryTable data={leaveHistory} />
              </div>
            </div>
          </div>
        )}
        {activeTab === "attendance" && (
          <div className="w-full mx-auto px-4 py-3 relative">
            <div className="w-full mx-auto p-8 relative rounded-xl bg-white border border-[#a48572]/10">
              <div className="flex flex-col justify-start items-start gap-[20px]">
                <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
                  <p>
                    <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
                      Attendance History
                    </span>
                  </p>
                </div>
                <AttendanceTable
                  data={attendanceLog}
                  handleSelectTime={handleTimeSelect}
                />
                <Popup
                  isOpen={openImage}
                  onClose={handleClosePhoto}
                  title="Check In / Out Image"
                >
                  <div className="flex flex-col md:flex-row items-start gap-6 mt-[30px]">
                    <div className="flex flex-col gap-4 w-full md:w-1/2 mb-8">
                      <div className="text-[#c30f0a] text-lg">
                        Check In Image
                      </div>
                      <img
                        src={
                          selectedPhoto?.checkInImg
                            ? selectedPhoto?.checkInImg
                            : PlaceholderImage
                        }
                        alt="Check In Image"
                        className="w-full h-52 object-cover rounded-lg shadow-md"
                      />
                    </div>
                    <div className="flex flex-col gap-4 w-full md:w-1/2 mb-8">
                      <div className="text-[#c30f0a] text-lg">
                        Check Out Image
                      </div>
                      <img
                        src={
                          selectedPhoto?.checkOutImg
                            ? selectedPhoto?.checkOutImg
                            : PlaceholderImage
                        }
                        alt="Check Out Image"
                        className="w-full h-52 object-cover rounded-lg shadow-md"
                      />
                    </div>
                  </div>
                </Popup>
              </div>
            </div>
          </div>
        )}
      </div>

      <Popup
        isOpen={noUserOpen}
        onClose={() => (window.location = "/employees")}
        title="Error"
      >
        <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/80 text-left">
              User Not Found!
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => (window.location = "/employees")}
            className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
          >
            Ok
          </button>
        </div>
      </Popup>
      <Popup
        isOpen={apiErrorOpen}
        onClose={() => (window.location = "/employees")}
        title="Error"
      >
        <div className="flex flex-col gap-6 mt-[30px] mb-[30px]">
          <div className="flex flex-col gap-2">
            <p className="text-sm text-[#142b70]/80 text-left">
              Something went wrong! Please try again later.
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={() => (window.location = "/employees")}
            className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium disabled:opacity-50"
          >
            Ok
          </button>
        </div>
      </Popup>
      <ToastContainer />
    </>
  );
};

export default ViewEmployee;
